import { render } from "./LiveStreaming.vue?vue&type=template&id=313b45a1"
import script from "./LiveStreaming.vue?vue&type=script&lang=js"
export * from "./LiveStreaming.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__